import { EkonecVyporadani } from 'enums/isin/udaje/konecVyporadani';

const konecVyporadaniSelect = [
    {
        value: EkonecVyporadani.N,
        labelcz: 'ISIN_EMISE_WARRANT_KONEC_VYPORADANI_NATURAL'
    },
    {
        value: EkonecVyporadani.P,
        labelcz: 'ISIN_EMISE_WARRANT_KONEC_VYPORADANI_PENEZNI'
    },
    {
        value: EkonecVyporadani.NU,
        labelcz: 'ISIN_EMISE_WARRANT_KONEC_VYPORADANI_NEURCENO'
    }
];

export default konecVyporadaniSelect;
